import { Box, Card, Flex, Grid, Hide, Image, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import { EMAIL_TYPE, SMS_TYPE } from '../constants'
import OptInFormEmail from './OptInFormEmail'
import OptInFormSMS from './OptInFormSMS'

const DESKTOP_IMAGE_SIZE = '160px'
const MOBILE_IMAGE_SIZE = '104px'

const OptInFormCard = styled(Card)`
  border: 0;
`

const OptInImage = styled(Image)`
  max-width: ${(props) => props.maxWidth};
  object-fit: cover;
`

const OptInCard = ({
  altImageText,
  desktopImageAlignment = 'left',
  heading,
  imageUrl,
  isNameRequired = true,
  longFormat,
  mobileImageAlignment = 'left',
  optInForm,
  subheading,
  type,
  ...props
}) => {
  const form =
    optInForm ||
    (type === SMS_TYPE ? (
      <OptInFormSMS {...props} type={SMS_TYPE} />
    ) : (
      <OptInFormEmail {...props} isNameRequired={isNameRequired} type={EMAIL_TYPE} />
    ))

  const imageProps = {
    alt: altImageText,
    borderRadius: 'lg',
    height: '100%',
    src: imageUrl,
  }

  const desktopImageBoxProps = {
    minHeight: DESKTOP_IMAGE_SIZE,
    width: DESKTOP_IMAGE_SIZE,
  }
  const desktopOptInImage = imageUrl && (
    <OptInImage {...imageProps} data-testid='desktop-image' loading='lazy' maxWidth={DESKTOP_IMAGE_SIZE} />
  )
  const mobileImageBoxProps = {
    height: ['100%', MOBILE_IMAGE_SIZE],
    width: MOBILE_IMAGE_SIZE,
  }
  const mobileOptInImage = imageUrl && (
    <OptInImage
      {...imageProps}
      data-testid='mobile-image'
      loading='lazy'
      maxWidth={MOBILE_IMAGE_SIZE}
      width={MOBILE_IMAGE_SIZE}
    />
  )

  const title = (
    <Box>
      {heading && <Text textStyle='heading4'>{heading}</Text>}
      {subheading && (
        <Text textStyle='paragraph' mt={1}>
          {subheading}
        </Text>
      )}
    </Box>
  )

  return longFormat ? (
    <OptInFormCard>
      <Grid
        templateColumns={['1fr', null, null, '1fr 1fr']}
        justifyContent='space-between'
        alignItems='center'
        gap={2}
        width={1}
      >
        {title}
        {form}
      </Grid>
    </OptInFormCard>
  ) : (
    <OptInFormCard borderRadius='xl' boxShadowSize='sm'>
      <Hide xs sm md>
        <Flex p={3}>
          {imageUrl && desktopImageAlignment === 'left' && (
            <Box {...desktopImageBoxProps} mr={3}>
              {desktopOptInImage}
            </Box>
          )}
          <Flex flexDirection='column' justifyContent='center' width={1}>
            {title}
            {form}
          </Flex>
          {imageUrl && desktopImageAlignment === 'right' && (
            <Box {...desktopImageBoxProps} ml={3}>
              {desktopOptInImage}
            </Box>
          )}
        </Flex>
      </Hide>
      <Hide lg xl xxl p={1}>
        <Flex flexDirection='column' p={2}>
          <Flex justifyContent={mobileImageAlignment === 'right' ? 'space-between' : 'flex-start'}>
            {imageUrl && mobileImageAlignment === 'left' && (
              <Box pr={1}>
                <Box {...mobileImageBoxProps} mr={2}>
                  {mobileOptInImage}
                </Box>
              </Box>
            )}
            <Flex alignItems='center'>{title}</Flex>
            {imageUrl && mobileImageAlignment === 'right' && (
              <Box pl={1}>
                <Box {...mobileImageBoxProps} ml={2}>
                  {mobileOptInImage}
                </Box>
              </Box>
            )}
          </Flex>
          <Box width={1}>{form}</Box>
        </Flex>
      </Hide>
    </OptInFormCard>
  )
}

export default OptInCard
